import store from "store";

/**
 *
 * @param {String} [moduleName]
 * @return {Object[]}
 */
export default (moduleName = undefined) => {
  const types = store.getState().General.types;

  if (moduleName) {
    const MODULE = modules().where("name", moduleName).first();

    if (!MODULE) throw new TypeError(`Unknown module '${moduleName}'`);

    return types.where("forModuleId", MODULE.id);
  }

  return types;
};
